
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getOrderType, getOrderScheduledDate, getOrderTitle } from '@/utils/getters';
import OrderCard from '@/components/order-management/OrderCard.vue';

const namespace: string = 'auth';

@Component<ParentOrderCard>({
	components: {
		OrderCard
	}
})
export default class ParentOrderCard extends Vue {
	@Getter('isMarketplaceEnabled', { namespace }) private isMarketplaceEnabled!: Boolean;
	@Getter('isPizzabotLocation', { namespace }) private isPizzabotLocation!: boolean;
	@Getter('isPizzabotV2Location', { namespace }) private isPizzabotV2Location!: boolean;
	@Prop({ type: [Array, Object], default: () => [] }) private orders!: Order[] | Order;
	@Watch('orders', { deep: true, immediate: true })
	private onOrdersChanged(): void {
		if (this.isGroupedOrder) {
			this.tempOrder = (this.orders as Order[])?.length ? (this.orders as Order[])[0] : undefined;
		}
		else {
			this.tempOrder = this.orders as Order;
		}
	}

	private tempOrder: Order | undefined = {} as Order;

	private get isGroupedOrder(): boolean {
		return !!this.isMarketplaceEnabled || this.isPizzabotV2Location;
	}

	private get parentOrderType(): ParentOrderType {
		const orderType = getOrderType(this.tempOrder);

		if (this.isPizzabotLocation) {
			if (orderType.type === 'takeout') {
				return { type: 'pizzabot_takeout', icon: 'mdi-qrcode' };
			}
			return { type: 'pizzabot_dine_in', icon: 'mdi-monitor' };
		}

		return orderType;
	}

	private get orderTitle(): string {
		return getOrderTitle(this.tempOrder);
	}

	private get scheduledDate(): string | undefined {
		return getOrderScheduledDate(this.tempOrder);
	}

	private showModal(order: Order): void {
		this.$emit('show-modal', order);
	}
}
